import React, { useState, useRef } from 'react';

import { ThemeProps, withTheme } from 'styled-components';

import { Props as TimePickerProps } from 'components/TimePicker';

import { Content } from '../BookingSelectDate/styles';
import { Container, Label, Value } from './styles';

export interface RenderProps extends TimePickerProps {
  selectRef: React.RefObject<HTMLDivElement>;
}

interface Props extends ThemeProps<any> {
  label?: string;
  value?: string;
  children: (renderProps: RenderProps) => JSX.Element;
  onConfirm: (value: any) => void;
  disabled?: boolean;
  icon?: React.ReactNode;
  testId?: string;
  title: string;
  button: string;
  noLabel?: boolean;
  placeholder?: string;
}

const BookingSelectTime = ({
  label,
  value,
  disabled,
  children,
  onConfirm,
  icon,
  testId,
  title,
  button,
  placeholder,
  noLabel = false,
}: Props) => {
  const selectRef = useRef(null);

  const [showOptions, setShowOptions] = useState(false);

  const handleContainerClick = () => {
    setShowOptions(!showOptions);
  };

  const handleOptionsClose = () => {
    setShowOptions(false);
  };

  const handleConfirm = (value) => {
    setShowOptions(!showOptions);
    onConfirm(value);
  };

  return (
    <Container ref={selectRef} $disabled={disabled}>
      <Content onClick={() => (disabled ? null : handleContainerClick())} data-testid={testId}>
        {!noLabel && <Label>{label}</Label>}
        <Value active={!!value}>{value || placeholder || label}</Value>
      </Content>
      {icon}
      {children({
        show: showOptions,
        onClose: handleOptionsClose,
        selectRef,
        onConfirm: handleConfirm,
        selected: value,
        title,
        button,
      })}
    </Container>
  );
};

export default withTheme(BookingSelectTime);
